import api from 'core/api';

export const getProjects = (params) => api.get('/projects/', { params });

export const getSites = (params) => api.get('/projects/sites', { params });

export const getRecentProjects = () => api.get('/projects/recent');

export const getRecentSites = () => api.get('/projects/recent-sites');

export const getProject = (projectId) => api.get(`/projects/${projectId}`);

export const getProjectOutputs = (projectId) => api.get(`/projects/${projectId}/outputs`);

export const getProjectShares = (projectId) => api.get(`/projects/${projectId}/shares`);

export const createProject = (projectDetails) => api.post('/projects/', projectDetails);

export const updateProjectDetails = (projectId, projectDetails) =>
  api.put(`/projects/${projectId}/details`, projectDetails);

export const updateProjectMeasurementSystem = (projectId, measurementSystem) =>
  api.put(`/projects/${projectId}/measurement-system`, { measurementSystem });

export const updateProjectEmployeePopulation = (projectId, employeePopulation) =>
  api.put(`/projects/${projectId}/employee-population`, employeePopulation);

export const updateProjectAdditionalSpaces = (projectId, additionalSpaces) =>
  api.put(`/projects/${projectId}/additional-spaces`, additionalSpaces);

export const updateProjectSiteSpecificSpaces = (projectId, siteSpecificSpaces) =>
  api.put(`/projects/${projectId}/site-specific-spaces`, siteSpecificSpaces);

export const saveProjectOutputConfigurations = (projectId, configurations) =>
  api.post(`/projects/${projectId}/outputs`, configurations);

export const saveProjectAs = (projectId, saveAs) => api.post(`/projects/${projectId}/save-as`, saveAs);

export const duplicateProject = (projectId) => api.post(`/projects/${projectId}/duplicate`);

export const archiveProject = (projectId) => api.post(`/projects/${projectId}/archive`);

export const unarchiveProject = (projectId) => api.post(`/projects/${projectId}/unarchive`);

export const confidentialProject = (projectId) => api.post(`/projects/${projectId}/confidential`);

export const unconfidentialProject = (projectId) => api.post(`/projects/${projectId}/unconfidential`);

export const finalProject = (projectId) => api.post(`/projects/${projectId}/final`);

export const unfinalProject = (projectId) => api.post(`/projects/${projectId}/unfinal`);

export const shareProject = (projectId, share) => api.post(`/projects/${projectId}/share`, share);

export const unshareProject = (projectId, userId) => api.post(`/projects/${projectId}/unshare`, { userId });
